export const NAV_BAR_HEIGHT = 60;
const SIDE_MENU_WIDTH = 240;

const styles = {
  navContainer: {
    zIndex: 1001,
    backgroundColor: '#fff',
    margin: '0 -15px',
    width: '100%',
    padding: '0.5em 1em 0 0',
    boxShadow: 'rgba(0,0,0,.1) 0px 2px 12px',
    position: 'fixed',
    transition: 'max-height .2s ease',
    '@media (min-width: 600px)': {
      padding: '0.5em 2em',
    },
    '@media (min-width: 1200px)': {
      padding: '0.5em 2em',
      justifyContent: 'space-between',
    },
  },
  navHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '@media (min-width: 600px)': {
      justifyContent: 'normal',
    },
    '@media (min-width: 1200px)': {
      justifyContent: 'initial',
    },
  },
  logo: {
    width: 140,
    '@media (min-width: 600px)': {
      marginRight: '3em',
    },
    '@media (min-width: 1200px)': {
      marginLeft: 0,
      marginRight: '3em',
    },
  },
  switchChecked: {
    transform: 'translateX(18px)',
    '& + $switchBar': {
      backgroundColor: '#23AD68 !important',
      opacity: 1,
    },
  },
  switchIcon: {
    width: 18,
    height: 18,
    backgroundColor: '#fff',
  },
  switchBar: {
    marginTop: '-10px',
    width: 38,
    height: 20,
    borderRadius: 19 / 2,
  },
  user: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 8,
  },
  userName: {
    margin: '0 0 0 10px',
    fontWeight: 500,
    '& + p': {
      margin: '0 0 0 10px',
    },
  },
  avatar: {
    borderRadius: '50%',
    width: 40,
    height: 40,
  },
  closeSessionBtn: {
    padding: '12px 0',
  },
  labelLogout: {
    '@media (min-width: 600px)': {
      display: 'none',
    },
  },
  iconLogout: {
    display: 'none',
    '@media (min-width: 600px)': {
      display: 'block',
    },
  },
  alignmentUser: {
    padding: '1em',
    '@media (max-width: 599px)': {
      '&>div': {
        justifyContent: 'flex-start'
      }
    },
    '@media (min-width: 600px)': {
      padding: 0,
    },
  },
  sideMenu: {
    backgroundColor: '#E5EAEC',
    zIndex: 1000,
    position: 'fixed',
    overflowY: 'auto',
    maxHeight: '94%',
    padding: '30px 0 !important',
    width: SIDE_MENU_WIDTH,
    minWidth: 100,
    height: '100%',
    transition: 'transform .2s ease',
    transform: `translateX(-${SIDE_MENU_WIDTH}px)`,
    '& li': {
      margin: 0,
      padding: 0,
      display: 'flex',
      justifyContent: 'flex-end',
      '& a': {
        padding: '10px 24px',
        display: 'flex',
        alignItems: 'center',
        marginBottom: 10,
        width: SIDE_MENU_WIDTH,
        '& span': {
          fontSize: '0.8rem',
          color: '#227db2',
          lineHeight: 'normal'
        },
        '& svg': {
          width: 20,
          height: 20,
          color: '#227db2'
        },
        '&:hover':{
          backgroundColor: "rgba(46, 169, 242, 0.2)",
        },
        '&.active': {
          backgroundColor: 'white',
          position: 'relative',
          borderLeft: '3px solid #ff6512',
          paddingLeft: 21,
          '& span': {
            color: '#ff6512',
          },
          '& svg': {
            fill: '#ff6512',

          },
        },
      },
      '& a > svg': {
        margin: 0,
      },
    },
  },
  sideMenuAnimation: {
    transform: `translateX(0px)`,
  },
  container: {
    margin: '0 -15px',
    minHeight: `calc(100vh - ${NAV_BAR_HEIGHT}px)`,
  },
  content: {
    transition: 'all .2s ease',
    width: '100%',
    padding: '35px 0',
    marginLeft: 0,
    marginTop: NAV_BAR_HEIGHT,
    '@media (min-width: 600px)': {
      padding: '35px 30px',
    },
  },
  sideMenuOpen: {
    '@media (min-width: 1200px)': {
      width: `calc(100% - ${SIDE_MENU_WIDTH}px)`,
      marginLeft: SIDE_MENU_WIDTH,
    },
  },
  profileDD: {
    transition: 'transform .2s ease',
    transform: 'translateY(-220px)',
    '@media (min-width: 600px)': {
      transform: 'translateY(0px)',
    },
  },
  showProfileDD: {
    transform: 'translateY(0px)',
  },
  logoSwitch: {
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItems: 'center',
    '@media (min-width: 600px)': {
      flexDirection: 'row',
    },
  }
};

export default styles;
